// Minimal RFC 2047 encoded-word decoder for Subject headers
// Supports formats like =?UTF-8?B?...?= and =?UTF-8?Q?...?=

function decodeQuotedPrintable(str) {
  // Replace underscores with spaces per RFC 2047 Q-encoding
  const replaced = str.replace(/_/g, ' ');
  // Decode =XX hex bytes
  return replaced.replace(/=([0-9A-Fa-f]{2})/g, (_, hex) => {
    try {
      return String.fromCharCode(parseInt(hex, 16));
    } catch (e) {
      return '=' + hex;
    }
  });
}

function decodeEncodedWord(word) {
  // =?charset?encoding?text?=
  const match = /^=\?([^?]+)\?([bBqQ])\?([^?]*)\?=$/.exec(word);
  if (!match) return word;
  const charset = match[1].toLowerCase();
  const encoding = match[2].toUpperCase();
  const text = match[3];

  try {
    let bytes;
    if (encoding === 'B') {
      // Base64
      const b64 = text.replace(/\s+/g, '');
      // atob is not available in Node sometimes, use Buffer if available
      if (typeof window === 'undefined') {
        bytes = Buffer.from(b64, 'base64');
      } else {
        const bin = atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        bytes = arr;
      }
    } else {
      // Quoted-printable
      const qp = decodeQuotedPrintable(text);
      // Convert to bytes as UTF-8 assumptions if charset utf-8/utf8
      // For other charsets we fall back to direct string
      if (charset.includes('utf-8') || charset === 'utf8') {
        if (typeof TextEncoder !== 'undefined') {
          bytes = new TextEncoder().encode(qp);
        } else if (typeof Buffer !== 'undefined') {
          bytes = Buffer.from(qp, 'utf8');
        } else {
          return qp;
        }
      } else {
        return qp; // best-effort for non-UTF charsets
      }
    }

    // Decode bytes according to charset
    if (charset.includes('utf-8') || charset === 'utf8') {
      if (typeof TextDecoder !== 'undefined') {
        return new TextDecoder('utf-8').decode(bytes);
      }
      if (typeof Buffer !== 'undefined') {
        return Buffer.from(bytes).toString('utf8');
      }
    }

    // Fallback: try UTF-8, else raw
    if (typeof TextDecoder !== 'undefined') {
      return new TextDecoder('utf-8').decode(bytes);
    }
    if (typeof Buffer !== 'undefined') {
      return Buffer.from(bytes).toString('utf8');
    }
  } catch (e) {
    // ignore and return original word
  }
  return word;
}

export function decodeMimeWords(input) {
  if (!input || typeof input !== 'string') return input;
  // Unfold potential CRLF + WSP folding within the value (if any)
  const unfolded = input.replace(/\r?\n[\t ]+/g, ' ');
  // Decode multiple encoded words across the whole string
  return unfolded.replace(/=\?[^?]+\?[bBqQ]\?[\s\S]*?\?=/g, (m) => decodeEncodedWord(m));
}

export default { decodeMimeWords };


